export const SET_CUSTOMER_DETAILS = 'SET_CUSTOMER_DETAILS';

export const setCustomerDetails = (data) => ({
  type: SET_CUSTOMER_DETAILS,
  data,
});
